import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'material_cutoff'

export const dataPointDefinition = {
  retracedId: 'material_cutoff',
  name: 'Material cut off',
  meta: {
    unit: 'PERCENTAGE',
  },
  fieldTypeId: 'NUMBER_UOM',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PERCENTAGE',
      name: 'Percentage',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
        minimum: 0,
        maximum: 100,
      },
      unit: {
        type: 'string',
        enum: ['PERCENTAGE'],
        minLength: 1,
      },
    },
    required: ['value', 'unit'],
  },
  externalIds: [],
  sortingId: 560,
  sectionId: '2.1.2.1',
  impactArea: 'Production Waste',
  impactAreaId: 'PRODUCTION_WASTE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
